module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-select', {
    ref: "multiselect",
    attrs: {
      "options": _vm.options,
      "label": _vm.label
    },
    on: {
      "search": _vm.onSearch
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }, {
      key: "selected-option",
      fn: function(option) {
        return [_vm._v("\n    " + _vm._s(option[_vm.label]) + "\n  ")]
      }
    }]),
    model: {
      value: (_vm.valueData),
      callback: function($$v) {
        _vm.valueData = $$v
      },
      expression: "valueData"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-502747b6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/global/components/SelectRemote.vue
// module id = 898
// module chunks = 0